// Single source of truth for facts that appear in more than one place.
// Change a value here and every page, email-facing link and legal page picks it up.

export const SITE = {
  name: 'Plastic Analytics',
  url: 'https://plasticanalytics.com',
  supportEmail: 'support@plasticanalytics.com',
  privacyEmail: 'support@plasticanalytics.com',
  // Legal identity. Fill the placeholders before launch — French law (LCEN art. 6) requires them on the Legal notice page.
  operator: 'Dr Joseph Levermore',
  // Legal form of the organisation that runs the service (e.g. association loi 1901, SAS, entrepreneur individuel).
  operatorType: '[Legal form — to be completed]',
  registeredAddress: '[Registered address — to be completed]',
  siret: '[SIRET number — to be completed]',
  vatNumber: '[Intra-EU VAT number — to be completed, if registered]',
  publicationDirector: 'Dr Joseph Levermore',
  host: 'Google Cloud EMEA Limited (Firebase Hosting), 70 Sir John Rogerson’s Quay, Dublin 2, Ireland',
  consumerMediator: '[Consumer mediator name and website — required in France for consumer sales (Code de la consommation, art. L612-1)]',
  governingLaw: 'France',
  // Where data is processed. Keep in step with functions/main.py (FUNCTIONS_REGION) and the Firebase console.
  regions: {
    functions: 'us-central1',
    functionsLabel: 'United States (Iowa, us-central1)',
    database: '[Firestore / Storage location — confirm in the Firebase console]',
    preprocessing: 'European Union (Paris, europe-west9)',
  },
  social: {
    linkedin: 'https://www.linkedin.com/company/plasticanalytics',
    x: 'https://twitter.com/plasticanalytic',
  },
};

// Versions of the documents a user agrees to. Bump when the text changes materially;
// users are asked to review again on their next visit.
export const LEGAL_VERSIONS = {
  terms: '2026-10-20',
  privacy: '2026-10-20',
  cookies: '2026-10-20',
};

export const MIN_AGE = 18;
export const TRIAL_DAYS = 14;
export const GUEST_DAILY_LIMIT = 5;
export const GUEST_RETENTION_DAYS = 30;

export const PRICING = {
  currency: 'EUR',
  monthly: { id: 'monthly', label: 'Monthly', perMonth: 40, billed: 40, interval: 'month' },
  annual: { id: 'annual', label: 'Annual', perMonth: 30, billed: 360, interval: 'year' },
  // Shown under every price. EU consumer law requires the final price to be clear before payment.
  taxNote: 'Any VAT due for your country is shown at checkout before you pay.',
};

// Benchmark figures from the peer-reviewed paper. Confirm before publishing if the models change.
export const ACCURACY = { raman: 96.9, ftir: 97.9 };

export const PUBLICATION = {
  title: 'PlasticAnalytics: A Deep Learning-Powered Spectral Library and Analytical Suite',
  journal: 'Environmental Science & Technology',
  year: 2026,
  url: 'https://pubs.acs.org/doi/10.1021/acs.est.6c01309',
  citation:
    'Levermore, J. M., Kelly, F. J., Wright, S. L. (2026). PlasticAnalytics: A Deep Learning-Powered Spectral Library and Analytical Suite. Environmental Science & Technology. https://doi.org/10.1021/acs.est.6c01309',
};

// FTIR analysis and contributions on the web are paused until the FTIR models are ready.
// Explore still shows FTIR spectra. Change or remove this when FTIR goes live.
export const FTIR_WEB_LAUNCH = '1 November';

export const ENDPOINTS = {
  preprocess: 'https://preprocess-api-917872845779.europe-west9.run.app/preprocess',
  classify: {
    eu: 'https://raman-api-eu-917872845779.europe-west9.run.app/classify',
    us: 'https://raman-api-us-917872845779.us-central1.run.app/classify',
    asia: 'https://raman-api-asia-917872845779.asia-southeast1.run.app/classify',
  },
};

export const GA_MEASUREMENT_ID = 'G-9CC5N8N5QZ';